'use strict';

(function (global) {

  // Идентификатор для хранения приватного свойства с селектором кнопки тулбара
  const toolbarButtonSelectorPrivatePropertyKey = Symbol('selector');

  // Идентификатор для хранения приватного свойства с действием кнопки тулбара
  const toolbarButtonActionPrivatePropertyKey = Symbol('action');

  /**
   * Кнопка тулбара предпросмотра.
   *
   * @namespace window.Core.preview.toolbar
   * @since 5.7.0
   */
  class BaseToolbarButton {

    constructor(selector, action) {
      this[toolbarButtonSelectorPrivatePropertyKey] = $(`#preview-panel ${selector}`);
      this[toolbarButtonActionPrivatePropertyKey] = action;
      this._bindAction();
    }

    /**
     * Кнопка тулбара предпросмотра.
     *
     * @private
     * @property _jButton
     * @return {Object} jQuery-объект кнопки тулбара предпросмотра.
     */
    get _jButton() {
      return this[toolbarButtonSelectorPrivatePropertyKey];
    }

    /**
     * Действие кнопки предпросмотра.
     *
     * @private
     * @property _action
     * @return {function} Действие предпросмотра из пространства имён window.Core.preview.actions.
     */
    get _action() {
      return this[toolbarButtonActionPrivatePropertyKey];
    }

    /**
     * Является ли кнопка кликабельной
     *
     * @property isActive
     * @return {boolean} TRUE - если кнопка кликабельна (не disabled), иначе - FALSE.
     */
    get isActive() {
      return !this._jButton.hasClass('btn-disabled');
    }

    /**
     * Привязать функцию к событию нажатия на кнопку.
     *
     * @method _bindAction
     * @private
     */
    _bindAction() {
      this._jButton.on('click', () => {
        if (this.isActive) {
          if (typeof this._action === 'function') {
            this._performAction();
          } else {
            console.error(`${this._action} is ${typeof this._action}. Should be function instead`);
          }
        }
        return false;
      });
    }

    /**
     * Выполнить действие кнопки.
     *
     * @method _performAction
     * @private
     */
    _performAction() {
      this._action();
    }
  }

  global.BaseToolbarButton = BaseToolbarButton;

})(window.Core.preview.toolbar);
